export const trackerArticleId = 236;
